module.exports = __webpack_public_path__ + "static/img/icon8-10.b261efc9.png";